//import KTAPI from "../api/index.api";
//import { KTMenuInit } from "../components/menu";
import { KTLang } from "../lang/lang";

import { pages } from "../controllers/index";

import { User, _handler, _user } from "../classes/index.classes";
import KTAPI, { user } from "../api/index.api";
import { ioSocket } from "../mm/index.mm";

import { initPartySystem } from "../controllers/party.controller";

import { soundManager } from "../classes/index.classes";

const isTokenExpired = (token) => {try{let a = Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000; return a;}catch(e){return true;}};
const isValidMongoId = id => /^[0-9a-fA-F]{24}$/.test(id);
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

import { soloOffscreenInit } from "../controllers/solo.controller";
import lobby from "../controllers/lobby.controller";

let socketInited = false;

// Función para mostrar u ocultar el loader con promesas manuales
const toggleLoader = (targetSelector, displayTime, loadingProgress) => {
    return new Promise(resolve => {
      var loaderContainer = $(targetSelector).find('.loader');
  
      if (loaderContainer.length === 0) {
        var loader = $("<div class='loader'></div>");
        var loaderA = $(`<div class='loader-a' style="background: url('assets/media/logos/loader-a.png') no-repeat;"></div>`);
        var loaderB = $(`<div class='loader-b' style="background: url('assets/media/logos/loader-b.png') no-repeat 0 100%;"></div>`);
        var loadingText = $('<div class="loading-text" data-i18n="example.loadng"></div>');

        loadingText.localize();
  
        loaderA.append(loaderB);
        loader.append(loaderA);
        //loader.append(loadingText);
        $(targetSelector).append(loader);
  
        // Si no hay animación, resuelve la promesa inmediatamente
        if (!(displayTime || loadingProgress)) {
          resolve();
          return;
        }
  
        loader.fadeIn(500, function () {
          if (loadingProgress !== undefined) {
            var animationDuration = (loadingProgress >= 0) ? loadingProgress : 2;
            loaderB.css('animation-duration', animationDuration + 's');
          }
  
          if (displayTime !== undefined && displayTime !== 0) {
            setTimeout(function () {
              loader.fadeOut(500, function () {
                loader.remove();
              });
            }, displayTime);
          }
          // Resuelve la promesa después de mostrar el loader
          resolve();
        });
      } else {
        // Si no hay animación, resuelve la promesa inmediatamente
        if (!(displayTime || loadingProgress)) {
          loaderContainer.remove();
          resolve();
          return;
        }
  
        loaderContainer.fadeOut(500, function () {
          loaderContainer.remove();
          // Resuelve la promesa después de ocultar el loader
          resolve();
        });
      }
    });
  };


var router;
var KTRouter = function(){

    router = new Navigo("/");
        
    const render = async (page, params = {}, onlyafter = false, dependpag = '', submenu = '') => {        

        console.log("rendering",page);
        
        let pag = dependpag == '' ? page : dependpag;
        page = pages[page];


        
        if(!onlyafter)
        {
            console.log(page);
            if(page.root)
            {
                if(pag == 'inroot' && $('#kt_aside').length > 0)   return;                
                if(page.rerender)   $("#root").html(Object.keys(params).length === 0 ? page.render() : page.render(params));            
            }
            else
            {
                if(page.rerender)
                {                    
                    if(pag == 'header' || pag == 'aside' || pag == 'toolbar')
                    {
                        if($(page.where).html().length > 0)
                        {
                            //console.log("avoid render ",pag);                            
                            return;
                        }
                    }
                    console.log("rendering -------> ",pag);
                    $(page.where).html(Object.keys(params).length === 0 ? page.render() : page.render(params));
                    
                }
                else
                {                    
                    if(!page.rendered) $(page.where).html(Object.keys(params).length === 0 ? page.render() : page.render(params));page.rendered = true;
                }


                //side active section
                if(page.where == '#kt_content')
                {                                        

                    if(submenu == '')
                    {
                        $(".side-sub").removeClass('active');
                        if(!$("#where-"+pag).hasClass('show'))
                        {                        
                            $(".side-item").removeClass('here').removeClass('show');
                            $("#where-"+pag).addClass("here").addClass("show");
                        }
                    }
                    else{            
                                             
                        $(".side-item").removeClass('here').removeClass('show');
                        $("#where-"+pag).addClass("here").addClass("show");
                        

                        if(!$("#sub-"+submenu).hasClass('active'))
                        {
                            $(".side-sub").removeClass('active');
                            $("#sub-"+submenu).addClass("active");
                        }
                    }
                }
            }
        }
        Object.keys(params).length === 0 ? await page.after_render() : await page.after_render(params);

        //fixes of dynamic load
        $(".tooltip").remove();
        await KTLang.update();
        await KTDrawer.init();
        await KTApp.init();
        await router.updatePageLinks();
        
        
    }

    const renderStatics = async () => {
        
        await render('inroot');
        await render('header');
        await render('toolbar');
        await render('aside'); 
        await render('footer');
        KTLayoutAside.init();
        KTMenu.createInstances();
    }

    const checkLogin = async () => {

        const token = KTCookie.get("token");
        if(token == null || isTokenExpired(token)) return false;
        KTAPI.me = await KTAPI.getMe();
        _user.me = await KTAPI.getMe();
        if(KTAPI.me === undefined || KTAPI.me.steamid === undefined) return false;
        return true;        
    };

    const isAuthValid = async () => {

        const token = KTCookie.get("token");
        if(token == null || isTokenExpired(token)) return false; //no tiene token o esta expirado

        //const backcheck = await KTAPI.checkAuth();
        //if(backcheck.message !== "ok") return false; //falso o cualquier cosa

        return true;
        
    }

    router.checkLogin = checkLogin;
    router.isAuthValid = isAuthValid;
    router.render = render;


    /**
     * 
     * ROUTER STUFF
     * 
     */

    router.notFound(() => {
        //router.navigate('error');
        router.resolve("error");
    });
    
    router.hooks({        
        before: async (done, match) => {           
            //console.log(router.lastResolved());
            if(router.lastResolved() == null && !match.url.includes("authenticate/steam"))
            {
                toggleLoader("#root");
                const check = await isAuthValid();
                if(check)
                {
                    let user = await KTAPI.login();
                    if(user.message == 'error')
                    {
                        router.navigate('error');
                        return;
                    }
                    _user.authed = true;                    
                    _user.me = user.ret;
                    
                }
                else
                {
                    _user.authed = false;
                    _user.me = {};                    
                }

                if(!ioSocket.connected) await ioSocket.connect();
                toggleLoader("#root");
                done();
                
            }
            else if(match.url.includes("authenticate/steam"))
            {
                //if(!ioSocket.connected) await ioSocket.connect();
                done();
            } else if(socketInited)
            {                
                if(!ioSocket.connected) await ioSocket.connect();
                ioSocket.socket.emit('where', {url: match.url});                
            }
            
            done();
        }
    });

    router
    .on("/", async (match)  => {
                              
        /*if(await checkLogin()) 
        {  
            router.navigate('play');
        }
        else
        {
            if(KTCookie.get("justgo") == 1)
            {
                router.navigate('play');
            }
            else
            {
                await render('landing');                
            }            
        }*/
        if(_user.authed)
        {
            router.navigate('home');            
        }
        else
        {
            if(KTCookie.get("justgo") == 1)
            {
                router.navigate('home');
            }
            else
            {
                await render('landing');                
            }   
        }
   
    })
    //steam auth
    .on("/authenticate/steam", async ({ data, params, queryString }) => {

        toggleLoader("#root");
        
        KTCookie.set("token", params.token, {expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)});
        /*KTAPI.me = await KTAPI.getMe();
        
        if(KTAPI.me === undefined)
        {
            router.navigate('error');
        }
        else
        {            
            //KTAPI.user = new User(KTAPI.me);
            _user.me = KTAPI.me;
            router.navigate('play');
        }*/

        const check = await isAuthValid();
        if(check)
        {
            let user = await KTAPI.login();
            if(user.message == 'error')
            {
                router.navigate('error');
                return;
            }
            _user.authed = true;
            //_user.me = await KTAPI.getMe();
            _user.me = user.ret;
            toggleLoader("#root");
            router.navigate('home');
        }
        else
        {
            _user.authed = false;
            _user.me = {};
            toggleLoader("#root");
            router.navigate('error');
        }
        await ioSocket.connect();
    })

    .on("/site/terms-of-use", async ({ data, params, queryString }) => {
        await renderStatics();
        await render('tos');
    })
    .on("/site/code-of-conduct", async ({ data, params, queryString }) => {
        await renderStatics();
        await render('conduct');
    })
    .on("/site/privacy-policy", async ({ data, params, queryString }) => {
        await renderStatics();
        await render('privacy');
    })
    .on("/site/about", async ({ data, params, queryString }) => {
        await renderStatics();        
        await render("about");
    })

    .on("/posts", async ({ data, params, queryString }) => {
        await renderStatics();
        await render('social');
    })
    .on("/play", async ({ data, params, queryString }) => {                
        await renderStatics();
        await render('play');
        //router.navigate('play/pug');
    })
    .on("/play/:sub", async ({ data, params, queryString }) => {       
        await renderStatics();
        await render(data.sub, {}, false, 'play', data.sub);
    })
    .on("/playtest", async ({ data, params, queryString }) => {
        await renderStatics();
        await render('playtest');
    })
    .on("/players", async ({ data, params, queryString }) => {                
        await renderStatics();
        await render('players');
    })
    .on("/services/anticheat", async ({ data, params, queryString }) => {        
        await renderStatics();        
        await render("ac");
    })    
    .on("/error", async ({ data, params, queryString }) => {
        await render("error");
    })
    //.on("/user/:id/:primetab/:sectab", async ({ data, params, queryString }) => {
    .on("/user", async ({ data, params, queryString }) => {  
        if(!_user.authed) {router.navigate('error');return;}
        router.resolve("redirect?to="+'user/'+_user.me.communityid);
    })
    .on("/user/:id", async ({ data, params, queryString }) => {                       
        
        //console.log("🚀 ~ file: index.routes.js:237 ~ .on ~ lastResolved:", router.lastResolved());        
        //let subPaths = router.getCurrentLocation().url.split('/');
        //console.log("🚀 ~ file: index.routes.js:240 ~ .on ~ router.getCurrentLocation():", router.getCurrentLocation())
        //console.log("🚀 ~ file: index.routes.js:240 ~ .on ~ subPaths:", subPaths)
        
        
        const subPaths = router.getCurrentLocation().url.split('/');
        console.log("🚀 ~ file: index.routes.js:250 ~ .on ~ subPaths:", subPaths)
        
        let usercommunityid = data.id;
        let userinfo = _user.me.communityid == usercommunityid ? (_user.me.connected ? _user.me : await KTAPI.getUser({id:usercommunityid})) : await KTAPI.getUser({id:usercommunityid});
                        
        if(userinfo === undefined || userinfo.steamid === undefined || userinfo.steamid == null || userinfo.steamid == '')
        {
            router.navigate('error');
        }
        else
        {
            let st = await KTAPI.getPlayerStats({steamid: userinfo.steamid});
            if(st.message == 'done')
            {
                userinfo.stats = st.res;
            }
            else
            {
                userinfo.stats = null;
            }

            userinfo.rerender = true;

            await renderStatics();
            await render("user", userinfo);
        }
    })
    .on("/user/:id/:tab", async ({ data, params, queryString }) => {
        //console.log("🚀 ~ file: index.routes.js:237 ~ .on ~ lastResolved:", router.lastResolved());

        if(data.tab == 'settings')
        {
            if(!_user.authed || _user.me.communityid !== data.id) {router.navigate('error');return;}

            let usersettings = await KTAPI.getMySettings();

            if(usersettings === undefined || usersettings.message == 'error') {router.navigate('error');return;}

            usersettings.rerender = true;
            
            await renderStatics();
            await render("settings", usersettings);

            return;
        }
        
        let lastResolved = router.lastResolved();
        if(lastResolved == null)
        {
            let usercommunityid = data.id;
            let userinfo = _user.me.communityid == usercommunityid ? (_user.me.connected ? _user.me : await KTAPI.getUser({id:usercommunityid})) : await KTAPI.getUser({id:usercommunityid});
                            
            if(userinfo === undefined || userinfo.steamid === undefined || userinfo.steamid == null || userinfo.steamid == '')
            {
                router.navigate('error');
            }
            else
            {
                let st = await KTAPI.getPlayerStats({steamid: userinfo.steamid});
                if(st.message == 'done')
                {
                    userinfo.stats = st.res;
                }
                else
                {
                    userinfo.stats = null;
                }

                userinfo.tab = data.tab;
                userinfo.rerender = true;

                await renderStatics();
                await render("user", userinfo);
            }
        }
        else{
            lastResolved = lastResolved[0];
            if(lastResolved.url.includes("user") && lastResolved.data.id == data.id)
            {                
                let userinfo = {};                                                
                userinfo.tab = data.tab;
                userinfo.rerender = false;

                await renderStatics();
                await render("user", userinfo, true);
                
            }
            else
            {
                let usercommunityid = data.id;
                let userinfo = _user.me.communityid == usercommunityid ? (_user.me.connected ? _user.me : await KTAPI.getUser({id:usercommunityid})) : await KTAPI.getUser({id:usercommunityid});
                                
                if(userinfo === undefined || userinfo.steamid === undefined || userinfo.steamid == null || userinfo.steamid == '')
                {
                    router.navigate('error');
                }
                else
                {
                    let st = await KTAPI.getPlayerStats({steamid: userinfo.steamid});
                    if(st.message == 'done')
                    {
                        userinfo.stats = st.res;
                    }
                    else
                    {
                        userinfo.stats = null;
                    }

                    userinfo.tab = data.tab;
                    userinfo.rerender = true;

                    await renderStatics();
                    await render("user", userinfo);
                }
            }
        }

        
    })

    .on("/user/:id/:tab/:subtab", async ({ data, params, queryString }) => {
        //console.log("🚀 ~ file: index.routes.js:357 ~ .on ~ lastResolved:", router.lastResolved());        
        if(data.tab !== 'stats' && data.tab !== 'settings') {router.navigate('error');return;}
        let lastResolved = router.lastResolved();

        if(data.tab == 'settings')
        {
            if(lastResolved == null)
            {
                if(!_user.authed || _user.me.communityid !== data.id) {router.navigate('error');return;}

                let usersettings = await KTAPI.getMySettings();

                if(usersettings === undefined || usersettings.message == 'error') {router.navigate('error');return;}

                usersettings.tab = data.subtab;
                usersettings.rerender = true;
                
                await renderStatics();
                await render("settings", usersettings);
            }
            else
            {
                lastResolved = lastResolved[0];
                if(lastResolved.url.includes("user") && lastResolved.data.id == data.id && lastResolved.url.includes("settings"))
                {
                    let usersettings = {};                                                
                    usersettings.tab = data.subtab;
                    usersettings.rerender = false;
                    
                    await renderStatics();
                    await render("settings", usersettings, true);
                }
                else
                {
                    if(!_user.authed || _user.me.communityid !== data.id) {router.navigate('error');return;}

                    let usersettings = await KTAPI.getMySettings();

                    if(usersettings === undefined || usersettings.message == 'error') {router.navigate('error');return;}

                    usersettings.tab = data.subtab;
                    usersettings.rerender = true;
                    
                    await renderStatics();
                    await render("settings", usersettings);
                }
            }
            
            return;
        }
        if(data.tab == 'stats')
        {
            if(lastResolved == null)
            {
                let usercommunityid = data.id;
                let userinfo = _user.me.communityid == usercommunityid ? (_user.me.connected ? _user.me : await KTAPI.getUser({id:usercommunityid})) : await KTAPI.getUser({id:usercommunityid});
                                
                if(userinfo === undefined || userinfo.steamid === undefined || userinfo.steamid == null || userinfo.steamid == '')
                {
                    router.navigate('error');
                }
                else
                {
                    let st = await KTAPI.getPlayerStats({steamid: userinfo.steamid});
                    if(st.message == 'done')
                    {
                        userinfo.stats = st.res;
                    }
                    else
                    {
                        userinfo.stats = null;
                    }

                    userinfo.tab = data.tab;
                    userinfo.rerender = true;
                    userinfo.subtab = data.subtab;

                    await renderStatics();
                    await render("user", userinfo);
                }
            }
            else{
                lastResolved = lastResolved[0];
                if(lastResolved.url.includes("user") && lastResolved.data.id == data.id)
                {                
                    let userinfo = {};                                                
                    userinfo.tab = data.tab;
                    userinfo.rerender = false;
                    userinfo.subtab = data.subtab;

                    await renderStatics();
                    await render("user", userinfo, true);
                    
                }
                else
                {
                    let usercommunityid = data.id;
                    let userinfo = _user.me.communityid == usercommunityid ? (_user.me.connected ? _user.me : await KTAPI.getUser({id:usercommunityid})) : await KTAPI.getUser({id:usercommunityid});
                                    
                    if(userinfo === undefined || userinfo.steamid === undefined || userinfo.steamid == null || userinfo.steamid == '')
                    {
                        router.navigate('error');
                    }
                    else
                    {
                        let st = await KTAPI.getPlayerStats({steamid: userinfo.steamid});
                        if(st.message == 'done')
                        {
                            userinfo.stats = st.res;
                        }
                        else
                        {
                            userinfo.stats = null;
                        }

                        userinfo.tab = data.tab;
                        userinfo.rerender = true;
                        userinfo.subtab = data.subtab;

                        await renderStatics();
                        await render("user", userinfo);
                    }
                }
            }
        }
        
    })
    
    
    /*.on("/user/:id/friends", async ({ data, params, queryString }) => {
        let userinfo = await KTAPI.getUser({id:data.id});
        console.log(data.id);
        let friends = await KTAPI.getFriends({id:data.id});        
        console.log(friends);
       
    })
    .on("/user/:id/friends/add", async ({ data, params, queryString }) => {
        let userinfo = await KTAPI.getUser({id:data.id});
        let friends = await KTAPI.addFriend({friendid:'76561198074261634'});
        console.log(friends);
       
    })
    .on("/user/:id/friends/suggestions", async ({ data, params, queryString }) => {        
        let suggestions = await KTAPI.getSuggestions();
        console.log(suggestions);
       
    })*/
    .on("/home", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("home");
    })
    .on("/matches", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("matches");
    })

    .on("/match/:id", async ({ data, params, queryString }) => {
        //console.log(data.id, data.id.length);        
        if(isValidMongoId(data.id) == false) {router.navigate('error'); return;}
        let matchinfo = {};
        //matchinfo = await new Promise(resolve => ioSocket.socket.emit('lobby-info', {lobby_id:data.id}, data => resolve(data)));
        matchinfo = await KTAPI.getMatchDetails({matchid:data.id});
        console.log(matchinfo);
        
        await renderStatics();
        await render("matchdetails", matchinfo);
    })

    .on("/lobby/:id", async ({ data, params, queryString }) => {
        if(!isValidMongoId(data.id)) {router.navigate('error'); return;}
        let lobbyinfo = {};

        //lobbyinfo = await KTAPI.getLobby({lobby:data.id});
        //if(lobbyinfo.message == 'error') {router.navigate('error'); return;}
        await renderStatics();
        lobbyinfo._id = data.id;
        lobbyinfo.params = params;
        await render("lobby", lobbyinfo);
    })

    .on("/connect/:id", async ({ data, params, queryString }) => {
        let serverinfo = {};
        serverinfo = await KTAPI.getServer({server:data.id});
        if(serverinfo.message == 'error') {router.navigate('error'); return;}
        $("#enrouter").attr('src',`steam://connect/${data.id}`);
        alert("connecting to "+serverinfo.res.ip+":"+serverinfo.res.port);
        $("#enrouter").attr('src',`steam://connect/${data.id}`);
        router.navigate(`server/${data.id}`);
        return;
    })

    .on("/server/:id", async ({ data, params, queryString }) => {
        //console.log(data.id);
        //if(data.id.length != 24) {router.navigate('error'); return;}
        let serverinfo = {};
        //matchinfo = await new Promise(resolve => ioSocket.socket.emit('lobby-info', {lobby_id:data.id}, data => resolve(data)));
        //console.log(matchinfo);

        serverinfo = await KTAPI.getServer({server:data.id});
        //console.log(serverinfo);
        if(serverinfo.message == 'error') {router.navigate('error'); return;}
                
        await renderStatics();
        await render("server", serverinfo.res);
    })

    .on("/leaderboard", async ({ data, params, queryString }) => {
        await renderStatics();
        let info = {};
        info.rerender = true;
        info.tab = null;
        await render("leaderboard", info);
    })

    .on("/leaderboard/:tab", async ({ data, params, queryString }) => {
        
        let lastResolved = router.lastResolved();
        let info = {};
        if(lastResolved == null)
        {                           
            info.rerender = true;
            info.tab = data.tab;

            await renderStatics();
            await render("leaderboard", info);
            
        }
        else{

            lastResolved = lastResolved[0];
            console.log(lastResolved);
            if(lastResolved.url.includes("leaderboard"))
            {                                
                info.tab = data.tab;
                info.rerender = false;

                await renderStatics();
                await render("leaderboard", info, true);
                
            }
            else
            {
                info.rerender = true;
                info.tab = data.tab;

                await renderStatics();
                await render("leaderboard", info);
            }
        }

        
    })

    .on("/leaderboard/:tab/:subtab", async ({ data, params, queryString }) => {
        
        if(data.tab !== 'maps' && data.tab !== 'weapons') {router.navigate('error');return;}
        let lastResolved = router.lastResolved();
        let info = {};

        if(data.tab == 'maps' || data.tab == 'weapons')
        {
            if(lastResolved == null)
            {
                info.rerender = true;
                info.tab = data.tab;
                info.subtab = data.subtab;

                await renderStatics();
                await render("leaderboard", info);
            }
            else
            {
                lastResolved = lastResolved[0];
                if(lastResolved.url.includes("leaderboard") && lastResolved.data.tab == data.tab)
                {                
                    info.tab = data.tab;
                    info.rerender = false;
                    info.subtab = data.subtab;

                    await renderStatics();
                    await render("leaderboard", info, true);
                    
                }
                else
                {
                    info.rerender = true;
                    info.tab = data.tab;
                    info.subtab = data.subtab;

                    await renderStatics();
                    await render("leaderboard", info);
                }
            }

        }
    })

    .on("/news", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("news");
    })

    .on("/news/:slug", async ({ data, params, queryString }) => {
        await renderStatics();
        let news = await KTAPI.getNew(data.slug);
        if(news.message == 'error') {router.navigate('error'); return;}
        await render("news", news);
    })


    .on("/postnews", async ({ data, params, queryString }) => {
        let news = await KTAPI.postNews({
         news: {
            "title": "News and Updates 08/30/2024",
            "category": "update",
            "image": "assets/media/news/upd_1_en.jpg",
            "author_id": "STEAM_0:1:439743706",
            "translations": {
              "en": {
                "title": "News and Updates 08/30/2024",
                "description": "",
                "content": `
                <div style="text-align: left;">
                <p>Greetings, passionate Counter Strike 1.6 competitors! Over the past 8 weeks, we have experienced a significant increase in the number of players and matches from all over the Americas. I would like to take this opportunity to thank and greet you for supporting and fostering this platform, fair play, and competitiveness.</p>
                <p>We also appreciate all the feedback, concerns, and questions received about how we are progressing and what we are doing. From now on, platform updates, servers, anticheat, and everything happening with pDxPLAY will be published here and on our social networks so that we can stay closer.</p>
                <p>&nbsp;</p>
                <p><b class="text-white">WHAT ARE WE WORKING ON?</b>
                </p>
                <p>After the request of many users and due to the high flow of current players, we can now work on adding the custom matches, parties, and matchmaking services that have been ready for a long time. The introduction of these services will be gradual so that our users can familiarize themselves and get used to using these systems, starting with this update in the practice servers.</p>
                <p>In the short term, we will release a small social network within the platform so that users can stay more connected. Also, the match highlights service for the MVPs of each match will be available, where each video will be uploaded to our official YouTube channel.</p>
                <p>In the medium term, we will add event participation badges to player profiles on pDxPLAY, along with a record system that can be displayed as achievements and badges on the profile summary cards.</p>
                <p>In the long term, a token (points) system will be added to customize certain profile features, use advanced services, and as a rewards system. 
                    <br>We will carry all of this out hand in hand with our users, so we recommend adding us on social networks and staying tuned for our updates.</p>

                <p>&nbsp;</p>
                <p><b class="text-white">UPDATE NOTES FOR 08/30/2024</b>
                </p>
                <p></p>
                <p class="text-gray-800">[PLATFORM]
                    <br>
                </p>
                <p><em>QUICK START</em>
                    <br>
                </p>
                <ul>
                    <li>The <span class="text-primary">QUICK START</span> button has been enabled for Practice Servers - CSDM, which allows finding a match on the nearest available server with the lowest ping. This feature uses the <b>MatchMaking system</b>.
                        <br>Once the match is found, the player will be notified to either join the match from the notification or copy the server's IP.
                        <br>The player will have a reserved slot on the found server for 20 seconds, during which the notification will be visible.
                        <br>There is no cooldown if the player does not join the server within 20 seconds.</li>
                </ul>
                <p><em><br></em>
                </p>
                <p><em>TEAMSPEAK 3</em>
                </p>
                <ul>
                    <li>The TeamSpeak tab has been added to the "account settings" section.</li>
                    <li>Now, in this tab, it is possible to link the user from our TS3 server to the game account. By completing this procedure, the TS3 user will receive a verified badge, and the pDxPLAY profile link and current ranking level badge will be added to the TS3 user description.</li>
                    <li>This linking will serve to grant reserved slots on the TS3 server in the future.</li>
                </ul>
                <p><em><br></em>
                </p>
                <p><em>WEB</em>
                </p>
                <ul>
                    <li>The dropdown menu for the PLAY button on the sidebar has been changed to a section for selecting the game mode to progressively introduce the new custom matches and matchmaker options.</li>
                    <li>The correct display of the background (currently playing map) on the server information modal for the practice servers has been fixed.</li>
                    <li>The leaderboard section that was not correctly displaying statistics has been fixed.</li>
                </ul>
                <p>
                    <br>
                </p>
                <p class="text-gray-800">[SERVERS]</p>
                <p><em>CSDM</em>
                </p>
                <ul>
                    <li>Pressing the V key or typing /menu in the in-game chat allows you to customize the gaming experience on CSDM servers.</li>
                    <li>The option to not compete in the match has been added to the customization menu, allowing players to focus solely on their aim practice.</li>
                    <li>Customization settings are now saved globally and will be reflected across all CSDM practice server locations.</li>
                    <li>The quota for BOTs added during CSDM matches has been modified to include up to 10, including human players.</li>
                    <li>The difficulty of the BOTs has been increased from intermediate to advanced.</li>
                    <li>The BOTs' entry announcement in the chat has been disabled.</li>
                    <li>The match time countdown timer on the HUD, which was not displaying correctly, has been fixed.</li>
                </ul>
                <div>
                    <br>
                </div>
                <div class="text-gray-800">[MAINTENANCE]</div>
                <div>
                    <ul>
                        <li>Maintenance and update work is carried out daily from 08:00 GMT-5 to 12:00 GMT-5. During these hours, user flow is minimal, and during this period, it may not be possible to log in to the platform. We apologize for the inconvenience.</li>
                    </ul>
                    <div>
                        <br>
                    </div>
                    <div>Thank you for your attention. That's all for now. As you can see, we continue working to provide you with the best competitive environment, and keep enjoying pDxPLAY!
                        <br>
                    </div>
                </div>
            </div>

                `,
                "image": "assets/media/news/upd_1_en.jpg",
              },
              "es": {
                "title": "Novedades y Actualización 30/08/2024",
                "description": "",
                "content": `
                <div style="text-align: left;">
                    <p>¡Saludos apasionados de Counter Strike 1.6 competitivo! Durante las últimas 8 semanas hemos experimentado un gran incremento del número de jugadores y partidas desde todas partes de américa, por ello quisiera aprovechar esta oportunidad para agradecerles
                        y saludarlos por apoyar y fomentar ésta su plataforma, el juego limpio y la competitividad.</p>
                    <p>Agradecemos también todo el feedback, inquietudes y preguntas recibidas sobre a como estamos avanzando y que estamos haciendo por eso a partir de ahora las actualizaciones de la plataforma, servidores, anticheat y todo lo que ocurra con pDxPLAY serán
                        publicadas por aquí, y nuestras redes sociales para que estemos más cerca.</p>
                    <p>&nbsp;</p>
                    <p><b class="text-white">¿EN QUÉ ESTAMOS TRABAJANDO?</b>
                    </p>
                    <p>Tras el pedido de muchos usuarios y debido al alto flujo de jugadores actuales ya podemos trabajar en agregar el servicio de partidas personalizadas, parties y matchmaking que se encuentran listos desde hace mucho tiempo. La introducción de estos servicios será gradual para que nuestros usuarios puedan familiarizarse y acostumbrarse al uso de estos sistemas, empezando por esta actualización en los servidores de práctica.
                </p>
                <p>A corto plazo liberaremos una pequeña red social dentro de la plataforma para que los usuarios estén más en contacto, también el servicio de highlights de jugadas de partidas para los MVP de cada partida, donde cada video sera subido a nuestro canal oficial de youtube.</p>
                <p>A mediano plazo aregaremos al perfil de los jugadores badges de participación en eventos realizados en pdxplay además de la implementación de un sistema de records qué podrán ser exhibidos como logros e insignias en las tarjetas de resumen de perfil.</p>
                <p>A largo plazo un sistema de tokens (puntos) será agregado para poder customizar ciertas características del perfil, hacer uso de servicios avanzados y como sistema de recompensas.
                        <br>Todo esto vamos a llevarlo a cabo de la mano de nuestros usuarios por lo que les recomendamos que nos agreguen a nuestras redes sociales y estén atentos a nuestras actualizaciones.</p>
                    
                    <p>&nbsp;</p>
                    <p><b class="text-white">NOTAS DE LA ACTUALIZACIÓN DEL 30/08/2024</b>
                    </p>
                    <p>
                        
                    </p>
                    <p class="text-gray-800">[PLATAFORMA]
                        <br>
                    </p>
                    <p><em>QUICK START</em>
                        <br>
                    </p>
                    <ul>
                        <li>Se ha habilitado el botón <span class="text-primary">QUICK START</span> para los servidores de Práctica - CSDM, este permite encontrar una partida en el servidor más cercano disponible con menor ping, esta característica hace uso del <b>sistema de MatchMaking</b>.
                            <br>Una vez encontrada la partida se notificará al jugador para que pueda entrar a la partida desde la misma notificación o copiar el ip del servidor.
                            <br>El jugador obtendrá un slot reservado en el servidor encontrado durante 20 segundos, tiempo durante el cual la notificación será visible.
                            <br>No hay cooldown si al cabo de los 20 segundos el jugador no ha ingresado al servidor.</li>
                    </ul>
                    <p><em><br></em>
                    </p>
                    <p><em>TEAMSPEAK 3</em>
                    </p>
                    <ul>
                        <li>Se agregó a la pestaña TeamSpeak a la sección de "ajustes de la cuenta".</li>
                        <li>Ahora en esta pestaña es posible vincular el usuario de nuestro servidor de TS3 a la cuenta de juego. Al realizar este procedimiento el usuario de TS3 tendrá el badge de verificado además se agregará a la descripción de usuario de TS3 el enlace a su
                            perfil de pDxPLAY y se agregará el badge del nivel actual en el que se encuentra rankeado.</li>
                        <li>Esta vinculación en el futuro servirá para otorgar slots reservados en el servidor de TS3.</li>
                    </ul>
                    <p><em><br></em>
                    </p>
                    <p><em>WEB</em>
                    </p>
                    <ul>
                        <li>Se ha cambiado el menú desplegable del botón PLAY del sidebar por una sección para escoger la modalidad de juego con motivo de introducir progresivamente las nuevas opciones de custom matches y matchmaker.</li>
                        <li>Se ha arreglado la visualización correcta del fondo (mapa actualmente en juego) del modal de información de los servidores de práctica.</li>
                        <li>Se ha arreglado la sección de leaderboards que no mostraba correctamente las estadísticas.</li>
                    </ul>
                    <p>
                        <br>
                    </p>
                    <p class="text-gray-800">[SERVIDORES]</p>
                    <p><em>CSDM</em>
                    </p>
                    <ul>
                        <li>Presionando la tecla V o escribiendo /menu el en chat de juego es posible personalizar la experiencia de juego en los servidores de CSDM.</li>
                        <li>Se ha agregado al menu de personalización la opción de no competir en la partida, así los jugadores pueden centrarse solo en su práctica de puntería</li>
                        <li>Ahora los ajustes de personalización son guardados globalmente y se reflejarán en todas las localidades de servidores de práctica de CSDM.</li>
                        <li>La quota de BOTs que se agregan durante la partida de CSDM fue modificada hasta 10 incluyendo jugadores humanos.</li>
                        <li>La dificultad de los BOTs ha sido aumentada de intermedia a avanzada.</li>
                        <li>Se ha deshabilitado el anuncio de ingreso en el chat de los BOTs a la partida.</li>
                        <li>Se arregló el cronómetro de tiempo de partida en el HUD que no se mostraba correctamente.</li>
                    </ul>
                    <div>
                        <br>
                    </div>
                    <div class="text-gray-800">[MANTENIMIENTO]</div>
                    <div>
                        <ul>
                            <li>Los trabajos de mantenimiento y actualización se llevan a cabo desde las 08:00 GMT-5 hasta las 12:00 GMT-5 de cada día, durante estas horas del día el flujo de usuarios es mínimo, además durante este periodo puede que no sea posible iniciar sesión en
                                la plataforma, disculpen las molestias.</li>
                        </ul>
                        <div>
                            <br>
                        </div>
                        <div>Gracias por su atención, es todo por el momento. Como ven seguimos trabajando para brindarles el mejor entorno competitivo y ¡Sigan disfrutando de pDxPLAY!
                            <br>
                        </div>
                    </div>
                </div>
                `,
                "image": "assets/media/news/upd_1_es.jpg",
              },
              "pt": {
                "title": "Novidades e Atualização 30/08/2024",
                "description": "",
                "content": `
                <div style="text-align: left;">
                <p>Saudações, apaixonados pelo Counter Strike 1.6 competitivo! Nas últimas 8 semanas, experimentamos um aumento significativo no número de jogadores e partidas de todas as partes das Américas. Gostaria de aproveitar esta oportunidade para agradecer e cumprimentar vocês por apoiar e fomentar esta plataforma, o jogo limpo e a competitividade.</p>
                <p>Agradecemos também todo o feedback, dúvidas e perguntas recebidas sobre como estamos avançando e o que estamos fazendo. A partir de agora, as atualizações da plataforma, servidores, anticheat e tudo o que acontece com pDxPLAY serão publicadas por aqui e em nossas redes sociais para que possamos estar mais próximos.</p>
                <p>&nbsp;</p>
                <p><b class="text-white">EM QUE ESTAMOS TRABALHANDO?</b>
                </p>
                <p>Após o pedido de muitos usuários e devido ao alto fluxo de jogadores atuais, agora podemos trabalhar na adição dos serviços de partidas personalizadas, parties e matchmaking que estão prontos há muito tempo. A introdução desses serviços será gradual para que nossos usuários possam se familiarizar e se acostumar a usar esses sistemas, começando com esta atualização nos servidores de prática.</p>
                <p>No curto prazo, liberaremos uma pequena rede social dentro da plataforma para que os usuários possam estar mais conectados. Também o serviço de highlights das jogadas para os MVPs de cada partida, onde cada vídeo será carregado no nosso canal oficial do YouTube.</p>
                <p>No médio prazo, adicionaremos badges de participação em eventos ao perfil dos jogadores realizados na pdxplay, além da implementação de um sistema de recordes que poderão ser exibidos como conquistas e emblemas nos cartões de resumo do perfil.</p>
                <p>A longo prazo, um sistema de tokens (pontos) será adicionado para customizar certas características do perfil, usar serviços avançados e como um sistema de recompensas. 
                    <br>Vamos realizar tudo isso de mãos dadas com nossos usuários, por isso recomendamos que nos adicionem em nossas redes sociais e fiquem atentos às nossas atualizações.</p>

                <p>&nbsp;</p>
                <p><b class="text-white">NOTAS DA ATUALIZAÇÃO DE 30/08/2024</b>
                </p>
                <p></p>
                <p class="text-gray-800">[PLATAFORMA]
                    <br>
                </p>
                <p><em>QUICK START</em>
                    <br>
                </p>
                <ul>
                    <li>O botão <span class="text-primary">QUICK START</span> foi habilitado para os Servidores de Prática - CSDM, que permite encontrar uma partida no servidor disponível mais próximo com o menor ping. Este recurso usa o <b>sistema de MatchMaking</b>.
                        <br>Uma vez encontrada a partida, o jogador será notificado para que possa entrar na partida pela notificação ou copiar o IP do servidor.
                        <br>O jogador terá um slot reservado no servidor encontrado por 20 segundos, durante os quais a notificação ficará visível.
                        <br>Não há cooldown se o jogador não entrar no servidor dentro dos 20 segundos.</li>
                </ul>
                <p><em><br></em>
                </p>
                <p><em>TEAMSPEAK 3</em>
                </p>
                <ul>
                    <li>A aba TeamSpeak foi adicionada à seção de "configurações da conta".</li>
                    <li>Agora, nesta aba, é possível vincular o usuário do nosso servidor TS3 à conta do jogo. Ao concluir este procedimento, o usuário do TS3 receberá o emblema de verificado, e o link do perfil pDxPLAY e o emblema do nível de classificação atual serão adicionados à descrição do usuário do TS3.</li>
                    <li>Essa vinculação servirá no futuro para conceder slots reservados no servidor TS3.</li>
                </ul>
                <p><em><br></em>
                </p>
                <p><em>WEB</em>
                </p>
                <ul>
                    <li>O menu suspenso do botão PLAY na barra lateral foi alterado para uma seção de seleção do modo de jogo para introduzir progressivamente as novas opções de partidas personalizadas e matchmaking.</li>
                    <li>A exibição correta do fundo (mapa atualmente em jogo) no modal de informações dos servidores de prática foi corrigida.</li>
                    <li>A seção de leaderboards que não estava mostrando corretamente as estatísticas foi corrigida.</li>
                </ul>
                <p>
                    <br>
                </p>
                <p class="text-gray-800">[SERVIDORES]</p>
                <p><em>CSDM</em>
                </p>
                <ul>
                    <li>Pressionando a tecla V ou digitando /menu no chat do jogo é possível personalizar a experiência de jogo nos servidores CSDM.</li>
                    <li>A opção de não competir na partida foi adicionada ao menu de personalização, permitindo que os jogadores se concentrem apenas na prática de mira.</li>
                    <li>As configurações de personalização agora são salvas globalmente e serão refletidas em todas as localidades dos servidores de prática CSDM.</li>
                    <li>A cota de BOTs adicionados durante as partidas de CSDM foi modificada para incluir até 10, incluindo jogadores humanos.</li>
                    <li>A dificuldade dos BOTs foi aumentada de intermediária para avançada.</li>
                    <li>O anúncio de entrada dos BOTs no chat foi desativado.</li>
                    <li>O cronômetro de tempo da partida no HUD, que não estava sendo exibido corretamente, foi corrigido.</li>
                </ul>
                <div>
                    <br>
                </div>
                <div class="text-gray-800">[MANUTENÇÃO]</div>
                <div>
                    <ul>
                        <li>Os trabalhos de manutenção e atualização são realizados diariamente das 08:00 GMT-5 às 12:00 GMT-5. Durante essas horas, o fluxo de usuários é mínimo, e durante esse período, pode não ser possível fazer login na plataforma. Pedimos desculpas pelo transtorno.</li>
                    </ul>
                    <div>
                        <br>
                    </div>
                    <div>Obrigado pela atenção, é tudo por agora. Como podem ver, continuamos trabalhando para oferecer o melhor ambiente competitivo, e continuem aproveitando o pDxPLAY!
                        <br>
                    </div>
                </div>
            </div>

                `,
                "image": "assets/media/news/upd_1_br.jpg",
              }
            }
          }   
        });
    })
    
    .on("/services/client", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("client");
    })

    .on("/services/faq", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("support");
    })
    .on("/bans", async ({ data, params, queryString }) => {
        await renderStatics();
        await render("banlist");
    })
    .on("/logout", async ({ data, params, queryString }) => {
        let ret = await KTAPI.logout();
        ioSocket.socket.disconnect();        
        KTCookie.remove('token');
        //router.navigate('/');
        window.location.replace("/");
        //setTimeout(() => {
        //    ioSocket.connect();
        //}, 1000);
    })

    .on("/redirect", async ({ data, params, queryString }) => {
        router.navigate(params.to);
    })

    .on("/livestream", async ({ data, params, queryString }) => {
        //console.log(params);
        //console.log(queryString);
        await render("livestream");
    })
    
    .on((match) => {
        
    })
    .resolve();

    return {

        navigate: async function(where) {
            router.navigate(where);
        },
        
    };

}();


$(async function(){    
    //await router.render('offscreen');
    $(document).on('click', '.btn', function(e){
        //e.preventDefault();
        soundManager.playSound('click');
    });
    $(document).on('mouseenter', '.btn', function(e){
        //e.preventDefault();
        soundManager.playSound('hover');
    });
    $(document).on('click', 'a', function(e){
        //e.preventDefault();
        soundManager.playSound('click');
    });
    $(document).on('mouseenter', 'a', function(e){
        //e.preventDefault();
        soundManager.playSound('hover');
    });
});

_handler.on('socket-connected', async () =>{
    if(ioSocket.reconnected == 0)
    {
        if(_user.authed) 
        {
                await initPartySystem();
                await soloOffscreenInit();
                await router.render('offscreen');
        }
        else
            await router.render('offscreen', {}, true);
    }
    else
    {        
        let is = router.getCurrentLocation().url;
        //console.log("🚀 ~ file: index.routes.js:370 ~ _handler.on ~ router.getCurrentLocation():", router.getCurrentLocation())
        router.resolve("redirect?to="+is);
    }
    ioSocket.socket.emit('where', {url: router.getCurrentLocation().url});
});

_handler.on('update-user', async (data) => {
    console.log("update-user ROUTES", data);
    if(_user.authed)
    {
        Object.keys(data).forEach(key => {
            _user.me[key] = data[key];
        });
    }
});

_handler.on('socket-init', async (data) => {
    socketInited = true;
});


export {router, toggleLoader};


// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTRouter;
}